import { useQuery } from '@tanstack/react-query';
import { getPropertyManagers } from '../service';

function usePropertyManagers() {
    const query = useQuery({
        queryKey: ['property-managers'],
        queryFn: () => getPropertyManagers(),
    });

    return query;
}

export { usePropertyManagers };
